import { useDispatch } from "react-redux";
import { Button } from "../../../../components/ui";
import { setOpenFilter } from "../bloc/beneficiariesSlice";
import useFilters from "./useFilters";

const Filters = () => {
  const dispatch = useDispatch();

  const {
    handleStatusClick,
    handleApplyFilters,
    handleResetFilters,
    status,
    setStatus,
    statusOptions,
    statusFilters,
  } = useFilters();

  const isFilterApplied = () => {
    return statusFilters.status.length > 0;
  };

  return (
    <>
      <div
        className="card_space_18 bg-gray"
        style={{ height: "calc(-8rem + 100vh)" }}
      >
        <div className="space_18">
          <div className="flex justify-between">
            <label className="block font-bold mb-2 text-sm">By Status</label>
            <span
              className="fs-14 color-red cursor-pointer"
              onClick={() => {
                setStatus([]);
              }}
            >
              Reset
            </span>
          </div>

          <div className="flex gap-2 flex-wrap">
            {statusOptions.map((t) => {

              const isAllSelected =
                status.length === statusOptions.filter((t) => t.value !== "ALL").length;

              const isSelected =
                t.value === "ALL"
                  ? isAllSelected
                  : status.includes(t.value) || isAllSelected;

              return (
                <button
                  key={t.value}
                  onClick={() => handleStatusClick(t.value)}
                  className={`px-4 py-2 border br-10 text-sm font-semibold 
          ${isSelected
                      ? "bg-primary text-white"
                      : "hover:bg-primary bg-white"
                    }`}
                >
                  {t.label}
                </button>
              );
            })}
          </div>

        </div>
      </div>

      <div className="bg-white flex absolute bottom-0 justify-between items-center gap-10 px-6 py-4 w-full border-t">
        <Button
          className="w-[100px]"
          onClick={() => {
            dispatch(setOpenFilter(false));
          }}
          variant="transparent"
        >
          Cancel
        </Button>

        <div className="flex gap-2">
          {isFilterApplied() && (
            <Button
              className=""
              onClick={() => {
                handleResetFilters();
              }}
              variant="lightRed"
            >
              Reset
            </Button>
          )}
          <Button
            className=""
            onClick={() => {
              handleApplyFilters();
            }}
            variant="contained"
          >
            Apply
          </Button>
        </div>
      </div>
    </>
  );
};
export default Filters;
